<script>

export default {
  name: 'ChannelPostMenu',
  props: {
    post: {type: Object, required: true},
    direct: {type: Boolean, default: false},
    likesOnly: {type: Boolean, default: false},
    calendarData: {type: Object, default: null}, // Calendar Data
  },

  data() {
    return {
      userId: this.$storage.get('mm_user_id'),
    }
  },

  methods: {
    downloadInCalendar() {
      const date = this.calendarData.date
      const startTime = this.calendarData.startTime
      const endTime = this.calendarData.endTime

      // 2024-10-08 10:30 -> 20241008T103000
      const startDateTimeStr = date.replace(/-/g, '') + 'T' + startTime.replace(/:/g, '') + '00'
      const endDateTimeStr = date.replace(/-/g, '') + 'T' + endTime.replace(/:/g, '') + '00'

      const icalString = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Zukunft Personal//Chat//EN
BEGIN:VEVENT
UID:${new Date().getTime()}@zukunft-personal.com
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')}
DTSTART:${startDateTimeStr}
DTEND:${endDateTimeStr}
SUMMARY:${this.calendarData.subject}
DESCRIPTION:${this.calendarData.description}
END:VEVENT
END:VCALENDAR
      `.trim()

      const blob = new Blob([icalString], { type: 'text/calendar' })

      // Create a download link for the ics file
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'appointment.ics'

      // Programmatically click the link to trigger the download
      link.click()
    }
  }
}
</script>

<template>
    <span class="c-post-menu me-2">
        <button class="btn btn-outline-light btn-sm me-1" title="confirm"
         @click.prevent="$emit('thumbsup', post.id)">&#128077;
        </button>
        <button v-if="calendarData" class="btn btn-outline-light btn-sm" title="calendar"
        @click.prevent="downloadInCalendar()">&#128197;
        </button>
        <button v-if="!calendarData" class="btn btn-outline-light btn-sm me-1" title="like"
         @click.prevent="$emit('like', post.id)">&#10084;&#65039;
        </button>
        <template v-if="!likesOnly">
          <button class="btn btn-outline-light btn-sm" title="reply"
          @click.prevent="$emit('reply', post.id)">
              <i class="fas fa-reply" style="color:grey"></i>
          </button>
          <button  v-if="userId != post.user_id && !direct"
          class="btn btn-outline-light btn-sm" title="reply private"
          @click.prevent="$emit('reply-private', post.id)">
              <i class="fas fa-user-lock" style="color:grey"></i>
          </button>
          <button v-if="userId == post.user_id"
          class="btn btn-outline-light btn-sm" title="edit"
          @click.prevent="$emit('edit', post.id)">
              <i class="fas fa-edit" style="color:grey"></i>
          </button>
          <button v-if="userId == post.user_id"
          class="btn btn-outline-light btn-sm" title="delete"
          @click.prevent="$emit('delete', post.id)">
              <i class="fas fa-trash" style="color:grey"></i>
          </button>
        </template>
    </span>
</template>

<style scoped>

.c-post-menu {
    position: absolute;
    right: 0;
    margin-top: -1rem;
    padding: .5rem;

    border: 1px solid lightgrey;
    border-radius:.25rem;
    background: white;
    z-index: 1000;
}

</style>